import 'babel-polyfill';
import {BodyComponent} from "../components/body/body-component";
import {DropzoneComponent} from "../components/dropzone/dropzone-component";
import {Form} from "../components/form/form";
import {FormField} from "../components/form-field/form-field";
import {FormFieldChecks} from "../components/form-field-checks/form-field-checks";
import {FormFieldDate} from "../components/form-field-date/form-field-date";
import {FormFieldInput} from "../components/form-field-input/form-field-input";
import {FormFieldRadio} from "../components/form-field-radio/form-field-radio";
import {FormFieldSelect} from "../components/form-field-select/form-field-select";
import {FormFieldTextarea} from "../components/form-field-textarea/form-field-textarea";
import {FormFieldModelSelector} from "../components/form-field-model-selector/form-field-model-selector";
import {GvfUiService} from "../../gvf/js/gvf-ui-service";
import {FormFieldSelectImage} from "../components/form-field-select-image/form-field-select-image";
import {ModHeader} from "../components/mod-header/mod-header";
import {ModHeaderProduct} from "../components/mod-header-product/mod-header-product";
import {ModFooter} from "../components/mod-footer/mod-footer";
import {FormFieldHtml} from "../components/form-field-html/form-field-html";
import {FormFieldFiles} from "../components/form-field-files/form-field-files";
import {FormFieldRating} from "../components/form-field-rating/form-field-rating";
import {FormFieldRepeater} from "../components/form-field-repeater/form-field-repeater";
import {FormFieldSignature} from "../../cp/components/form-field-signature/form-field-signature";
import {ModHeroVideo} from "../components/mod-hero-video/mod-hero-video";
import {ModContact} from "../components/mod-contact/mod-contact";
import {ModSlider} from "../components/mod-slider/mod-slider";
import {ModHeroAnimation} from "../components/mod-hero-animation/mod-hero-animation";
import {ModAgentsOne} from "../components/mod-agents-one/mod-agents-one";
import {ModAgentsTwo} from "../components/mod-agents-two/mod-agents-two";
import {ModAgentsThree} from "../components/mod-agents-three/mod-agents-three";
import {ModAgentsFour} from "../components/mod-agents-four/mod-agents-four";
import {ModAgentsFive} from "../components/mod-agents-five/mod-agents-five";
import {ModAgentsSix} from "../components/mod-agents-six/mod-agents-six";
import {ModAgentsSeven} from "../components/mod-agents-seven/mod-agents-seven";
import {ModAgentsEight} from "../components/mod-agents-eight/mod-agents-eight";
import {ModAgentsNine} from "../components/mod-agents-nine/mod-agents-nine";
import {ModHeroLiquid} from "../components/mod-hero-liquid/mod-hero-liquid";
import {ModHeroGlobe} from "../components/mod-hero-globe/mod-hero-globe";
import {ModTools} from "../components/mod-tools/mod-tools";
import {ModClients} from "../components/mod-clients/mod-clients";
import {ModFeatures} from "../components/mod-features/mod-features";
import {ModMultiSlide} from "../components/mod-testimonials/mod-testimonials";

GvfUiService.registerComponent(".js-body",BodyComponent);
GvfUiService.registerComponent(".js-form",Form);
GvfUiService.registerComponent(".js-form-field",FormField);
GvfUiService.registerComponent(".js-form-field-checks",FormFieldChecks);
GvfUiService.registerComponent(".js-form-field-date",FormFieldDate);
GvfUiService.registerComponent(".js-form-field-input",FormFieldInput);
GvfUiService.registerComponent(".js-form-field-radio",FormFieldRadio);
GvfUiService.registerComponent(".js-form-field-select",FormFieldSelect);
GvfUiService.registerComponent(".js-form-field-select-image",FormFieldSelectImage);
GvfUiService.registerComponent(".js-form-field-textarea",FormFieldTextarea);
GvfUiService.registerComponent(".js-form-field-html",FormFieldHtml);
GvfUiService.registerComponent(".js-form-field-files",FormFieldFiles);
GvfUiService.registerComponent(".js-form-field-rating",FormFieldRating);
GvfUiService.registerComponent(".js-form-field-model-selector",FormFieldModelSelector);
GvfUiService.registerComponent(".js-form-field-repeater",FormFieldRepeater);
GvfUiService.registerComponent(".js-form-field-signature",FormFieldSignature);
GvfUiService.registerComponent(".js-dropzone",DropzoneComponent);
GvfUiService.registerComponent(".js-mod-header",ModHeader);
GvfUiService.registerComponent(".js-mod-header-product",ModHeaderProduct);
GvfUiService.registerComponent(".js-mod-footer",ModFooter);
GvfUiService.registerComponent(".js-mod-contact",ModContact);
GvfUiService.registerComponent(".js-mod-slider",ModSlider);
GvfUiService.registerComponent(".js-mod-hero-animation",ModHeroAnimation);
GvfUiService.registerComponent(".js-mod-agents-one",ModAgentsOne);
GvfUiService.registerComponent(".js-mod-agents-two",ModAgentsTwo);
GvfUiService.registerComponent(".js-mod-agents-three",ModAgentsThree);
GvfUiService.registerComponent(".js-mod-agents-four",ModAgentsFour);
GvfUiService.registerComponent(".js-mod-agents-five",ModAgentsFive);
GvfUiService.registerComponent(".js-mod-agents-six",ModAgentsSix);
GvfUiService.registerComponent(".js-mod-agents-seven",ModAgentsSeven);
GvfUiService.registerComponent(".js-mod-agents-eight",ModAgentsEight);
GvfUiService.registerComponent(".js-mod-agents-nine",ModAgentsNine);
GvfUiService.registerComponent(".js-mod-hero-liquid",ModHeroLiquid);
GvfUiService.registerComponent(".js-mod-hero-globe",ModHeroGlobe);
GvfUiService.registerComponent(".js-mod-tools",ModTools);
GvfUiService.registerComponent(".js-mod-clients",ModClients);
GvfUiService.registerComponent(".js-mod-features",ModFeatures);
GvfUiService.registerComponent(".js-mod-testimonials",ModMultiSlide);

GvfUiService.registerDelayedComponent(".js-mod-gvml",()=>import("../components/mod-gvml/mod-gvml"));
GvfUiService.registerDelayedComponent(".js-mod-dynamic-form",()=>import("../components/mod-dynamic-form/mod-dynamic-form"));
GvfUiService.registerDelayedComponent(".js-mod-faqs",()=>import("../components/mod-faqs/mod-faqs"));
GvfUiService.registerDelayedComponent(".js-mod-custom-form",()=>import("../components/mod-custom-form/mod-custom-form"));
GvfUiService.registerDelayedComponent(".js-mod-cookies",()=>import("../components/mod-cookies/mod-cookies"));
GvfUiService.registerDelayedComponent(".js-mod-blog-post-detail",()=>import("../components/mod-blog-post-detail/mod-blog-post-detail"));
GvfUiService.registerDelayedComponent(".js-mod-blog-post-list-with-sidebar",()=>import("../components/mod-blog-post-list-with-sidebar/mod-blog-post-list-with-sidebar"));
GvfUiService.registerDelayedComponent(".js-dynamic-form-embed",()=>import("../components/dynamic-form-embed/dynamic-form-embed"));
GvfUiService.registerDelayedComponent(".js-mod-msg-wa-chat-link",()=>import("../components/mod-msg-wa-chat-link/mod-msg-wa-chat-link"));
GvfUiService.registerDelayedComponent(".js-mod-web-video-demo-search",()=>import("../components/mod-web-video-demo-search/mod-web-video-demo-search"));
GvfUiService.registerDelayedComponent(".js-mod-web-video-demo-detail",()=>import("../components/mod-web-video-demo-detail/mod-web-video-demo-detail"));

